import { QueryClient } from "react-query";

const STALE_TIME = 60 * 1000;
const FALLBACK_REFETCH_INTERVAL = 5 * 60 * 1000;

export const REALTIME_QUERY_KEYS = {
	viaje: ["viaje", "viajes", "viajes-activos", "todos-count", "finalizado-count", "en_curso-count", "programado-count", "home"],
	viaje_portuario: ["viajes-portuarios", "viaje-portuario", "home"],
	pago: ["pago", "pagos", "cliente", "home"],
	seguro: ["seguro", "seguros-todos-count", "seguros-siniestros-count", "cliente", "home"],
	siniestro: ["siniestro", "seguro", "seguros-todos-count", "seguros-siniestros-count"],
	cliente: ["cliente", "home"],
	usuario: ["usuario", "cliente"],
	empresa: ["empresa", "cliente"],
	rfc: ["rfc", "cliente"],
	transportista: ["transportistas", "cliente"],
	conductor: ["conductor_transportista", "transportistas"],
	unidad: ["unidad_transportista", "transportistas"],
	equipo: [],
	carta_porte: ["carta_porte", "viaje", "viajes"],
	precio_saas: ["precios-saas", "cliente"],
};

const FALLBACK_QUERY_KEYS = [
	"home",
	"viaje",
	"viajes",
	"viajes-activos",
	"viajes-portuarios",
	"pago",
	"pagos",
	"seguro",
	"siniestro",
	"transportistas",
];

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: STALE_TIME,
			refetchOnWindowFocus: true,
			refetchOnReconnect: true,
		},
	},
});

FALLBACK_QUERY_KEYS.forEach(queryKey => {
	queryClient.setQueryDefaults(queryKey, {
		refetchInterval: FALLBACK_REFETCH_INTERVAL,
		refetchIntervalInBackground: false,
	});
});

export function getRealtimeQueryKeys(entity) {
	return REALTIME_QUERY_KEYS[entity] || [];
}

export function invalidateRealtimeEntity(entity, filters) {
	getRealtimeQueryKeys(entity).forEach(queryKey => {
		if(filters) queryClient.invalidateQueries(queryKey, filters);
		else queryClient.invalidateQueries(queryKey);
	});
}

export function reconcileRealtimeQueries() {
	const queryKeys = new Set(Object.values(REALTIME_QUERY_KEYS).flat());
	queryKeys.forEach(queryKey => queryClient.invalidateQueries(queryKey));
}

export default queryClient;
